/**
 * discountManager.js
 * Gestion centralisée des réductions actives (activeDiscounts[]).
 * Règle : c'est toujours la réduction la plus élevée applicable qui est retournée.
 */

const _timers = {}

/**
 * Retourne le pourcentage de réduction le plus élevé applicable à une cible donnée.
 * @param {Array}  discounts  profile.activeDiscounts
 * @param {string} target     'casino' | 'shop' | 'blackmarket' | 'tradeTickets' | 'all'
 * @param {Object} options
 * @param {string} options.collectionId
 */
export function getBestDiscount(discounts, target, options = {}) {
  if (!Array.isArray(discounts) || !discounts.length) return 0
  const { collectionId = null } = options
  const now = Date.now()
  return discounts
    .filter(d =>
      d.percentage > 0 &&
      (
        d.target === 'all' ||
        d.target === target ||
        (d.target === 'collection' && collectionId && d.collectionId === collectionId && (target === 'shop' || target === 'blackmarket'))
      ) &&
      (!d.end || now <= d.end)
    )
    .reduce((max, d) => Math.max(max, d.percentage), 0)
}

/**
 * Met en place un setTimeout pour chaque réduction active.
 * Quand une réduction expire, appelle onExpire().
 * Efface automatiquement les anciens timers avant de reconfigurer.
 * @param {Object}   profile   instance Profile avec activeDiscounts[]
 * @param {Function} onExpire  callback à appeler à l'expiration
 */
export function setupDiscountTimers(profile, onExpire) {
  clearAllTimers()
  if (!profile || !Array.isArray(profile.activeDiscounts) || !profile.activeDiscounts.length) return
  const now = Date.now()
  profile.activeDiscounts.forEach(d => {
    if (d.end && d.end > now) {
      const delay = d.end - now
      const key = d.id || `${d.codeId}_${d.end}`
      _timers[key] = setTimeout(onExpire, delay)
    }
  })
}

/**
 * Annule tous les timers de réduction en cours.
 */
export function clearAllTimers() {
  Object.values(_timers).forEach(t => clearTimeout(t))
  Object.keys(_timers).forEach(k => delete _timers[k])
}
